export enum IdmApplicationOwnerType {
    None = 'None',
    TechnicalOwner = 'TechnicalOwner',
    BusinessOwner = 'BusinessOwner',
    InformationOwner = 'InformationOwner',
}